/**
 * Generische Filter-Operatoren für Feld-Vergleiche.
 * Diese Funktionen werden als Strings serialisiert und in CouchDB-Views verwendet.
 */

export const decodeHTML = function(s: string) {
	const el = document.createElement('div');
	el.innerHTML = s;
	return el.textContent;
}

// Einfache Vergleichsoperatoren
export const equals = function(lhs: any, rhs: any) { return lhs === rhs; };
export const notequals = function(lhs: any, rhs: any) { return !(lhs === rhs); };
export const lessOrEqual = function(lhs: any, rhs: any) { return lhs <= rhs; };
export const greaterOrEqual = function(lhs: any, rhs: any) { return lhs >= rhs; };
export const liesBetween = function(mhs: any, lhs: any, rhs: any) { return lhs <= mhs && mhs <= rhs; };

// String-Operatoren
export const stringIsEmpty = function(s: string) { return s === undefined || s == "" };
export const stringIsNotEmpty = function(s: string) { return s !== undefined && s != "" };
export const stringContains = function(lhs: any, rhs: any) { return lhs && lhs.toLowerCase().indexOf(rhs.toLowerCase()) >= 0 };
export const stringDoesNotContain = function(lhs: any, rhs: any) { return !lhs || lhs.toLowerCase().indexOf(rhs.toLowerCase()) === -1 };

// Number-Operatoren
export const numberIsEmpty = function(n: number) { return n === undefined };
export const numberIsNotEmpty = function(n: number) { return n !== undefined };

// Datum-Operatoren
export const dateEquals = function(lhs: any, rhs: any) {
	let day = true, month = true;
	const dotsRegex = /^((\d{1,2}\.)(\d{1,2}\.))?(\d{4})$/;
	const slashesRegex = /^(\d{1,2}\/)?(\d{1,2}\/)?(\d{4})$/;
	const makeDate = (date: any) => {
		if (!date) return null;
		if (typeof date === 'string') {
			const d =  date as string;
			const dots = d.match(dotsRegex);
			const slashes = d.match(slashesRegex);
			if (dots) {
				const dayVal = dots[1] ? parseInt(dots[2]) : 1;
				const monthVal = dots[1] ? parseInt(dots[3]) : 1;
				const yearVal = parseInt(dots[4]);
				day = day && !!dots[1];
				month = month && !!dots[1];
				return new Date(yearVal, monthVal - 1, dayVal);
			}
			else if (slashes) {
				const dayVal = !!slashes[1] && !!slashes[2] ? parseInt(slashes[1]) : 1;
				const monthVal = slashes[1] ? (slashes[2] ? parseInt(slashes[2]) : parseInt(slashes[1])) : 1;
				const yearVal = parseInt(slashes[3]);
				day = day && !!slashes[1] && !!slashes[2];
				month = month && !!slashes[1];
				return new Date(yearVal, monthVal - 1, dayVal);
			}
			else return new Date(d);
		}
		else if (date instanceof Date)
			return date as Date;
		else
			return null;
	};
	const l = makeDate(lhs);
	const r = makeDate(rhs);
	return l && r && l.getFullYear() === r.getFullYear() && (!month || l.getMonth() === r.getMonth()) && (!day || l.getDate() === r.getDate());
};

export const dateNotequals = function(lhs: any, rhs: any) {
	let day = true, month = true;
	const dotsRegex = /^((\d{1,2}\.)(\d{1,2}\.))?(\d{4})$/;
	const slashesRegex = /^(\d{1,2}\/)?(\d{1,2}\/)?(\d{4})$/;
	const makeDate = (date: any) => {
		if (!date) return null;
		if (typeof date === 'string') {
			const d =  date as string;
			const dots = d.match(dotsRegex);
			const slashes = d.match(slashesRegex);
			if (dots) {
				const dayVal = dots[1] ? parseInt(dots[2]) : 1;
				const monthVal = dots[1] ? parseInt(dots[3]) : 1;
				const yearVal = parseInt(dots[4]);
				day = day && !!dots[1];
				month = month && !!dots[1];
				return new Date(yearVal, monthVal - 1, dayVal);
			}
			else if (slashes) {
				const dayVal = !!slashes[1] && !!slashes[2] ? parseInt(slashes[1]) : 1;
				const monthVal = slashes[1] ? (slashes[2] ? parseInt(slashes[2]) : parseInt(slashes[1])) : 1;
				const yearVal = parseInt(slashes[3]);
				day = day && !!slashes[1] && !!slashes[2];
				month = month && !!slashes[1];
				return new Date(yearVal, monthVal - 1, dayVal);
			}
			else return new Date(d);
		}
		else if (date instanceof Date)
			return date as Date;
		else
			return null;
	};
	const l = makeDate(lhs);
	const r = makeDate(rhs);
	if (!l || !r) return false;
	if (l.getFullYear() !== r.getFullYear()) return true;
	if (month && l.getFullYear() === r.getFullYear() && l.getMonth() !== r.getMonth()) return true;
	if (month && day && l.getFullYear() === r.getFullYear() && l.getMonth() === r.getMonth() && l.getDate() !== r.getDate()) return true;
	return false;
};

export const dateLessOrEqual = function(lhs: any, rhs: any) {
	let day = true, month = true;
	const dotsRegex = /^((\d{1,2}\.)(\d{1,2}\.))?(\d{4})$/;
	const slashesRegex = /^(\d{1,2}\/)?(\d{1,2}\/)?(\d{4})$/;
	const makeDate = (date: any) => {
		if (!date) return null;
		if (typeof date === 'string') {
			const d =  date as string;
			const dots = d.match(dotsRegex);
			const slashes = d.match(slashesRegex);
			if (dots) {
				const dayVal = dots[1] ? parseInt(dots[2]) : 1;
				const monthVal = dots[1] ? parseInt(dots[3]) : 1;
				const yearVal = parseInt(dots[4]);
				day = day && !!dots[1];
				month = month && !!dots[1];
				return new Date(yearVal, monthVal - 1, dayVal);
			}
			else if (slashes) {
				const dayVal = !!slashes[1] && !!slashes[2] ? parseInt(slashes[1]) : 1;
				const monthVal = slashes[1] ? (slashes[2] ? parseInt(slashes[2]) : parseInt(slashes[1])) : 1;
				const yearVal = parseInt(slashes[3]);
				day = day && !!slashes[1] && !!slashes[2];
				month = month && !!slashes[1];
				return new Date(yearVal, monthVal - 1, dayVal);
			}
			else return new Date(d);
		}
		else if (date instanceof Date)
			return date as Date;
		else
			return null;
	};
	const dateStr = (d: Date) => {
		let result = d.getFullYear().toString();
		if (month)
			result += (d.getMonth() + 1).toString().padStart(2,'0');
		if (day)
			result += d.getDate().toString().padStart(2,'0');
		return result;
	};
	const l = makeDate(lhs);
	const r = makeDate(rhs);
	if (!l || !r) return false;
	return dateStr(l) <= dateStr(r);
};

export const dateGreaterOrEqual = function(lhs: any, rhs: any) {
	let day = true, month = true;
	const dotsRegex = /^((\d{1,2}\.)(\d{1,2}\.))?(\d{4})$/;
	const slashesRegex = /^(\d{1,2}\/)?(\d{1,2}\/)?(\d{4})$/;
	const makeDate = (date: any) => {
		if (!date) return null;
		if (typeof date === 'string') {
			const d =  date as string;
			const dots = d.match(dotsRegex);
			const slashes = d.match(slashesRegex);
			if (dots) {
				const dayVal = dots[1] ? parseInt(dots[2]) : 1;
				const monthVal = dots[1] ? parseInt(dots[3]) : 1;
				const yearVal = parseInt(dots[4]);
				day = day && !!dots[1];
				month = month && !!dots[1];
				return new Date(yearVal, monthVal - 1, dayVal);
			}
			else if (slashes) {
				const dayVal = !!slashes[1] && !!slashes[2] ? parseInt(slashes[1]) : 1;
				const monthVal = slashes[1] ? (slashes[2] ? parseInt(slashes[2]) : parseInt(slashes[1])) : 1;
				const yearVal = parseInt(slashes[3]);
				day = day && !!slashes[1] && !!slashes[2];
				month = month && !!slashes[1];
				return new Date(yearVal, monthVal - 1, dayVal);
			}
			else return new Date(d);
		}
		else if (date instanceof Date)
			return date as Date;
		else
			return null;
	};
	const dateStr = (d: Date) => {
		let result = d.getFullYear().toString();
		if (month)
			result += (d.getMonth() + 1).toString().padStart(2,'0');
		if (day)
			result += d.getDate().toString().padStart(2,'0');
		return result;
	};
	const l = makeDate(lhs);
	const r = makeDate(rhs);
	if (!l || !r) return false;
	return dateStr(l) >= dateStr(r);
};

export const dateLiesBetween = function(mhs: any, lhs: any, rhs: any) {
	let day = true, month = true;
	const dotsRegex = /^((\d{1,2}\.)(\d{1,2}\.))?(\d{4})$/;
	const slashesRegex = /^(\d{1,2}\/)?(\d{1,2}\/)?(\d{4})$/;
	const makeDate = (date: any) => {
		if (!date) return null;
		if (typeof date === 'string') {
			const d =  date as string;
			const dots = d.match(dotsRegex);
			const slashes = d.match(slashesRegex);
			if (dots) {
				const dayVal = dots[1] ? parseInt(dots[2]) : 1;
				const monthVal = dots[1] ? parseInt(dots[3]) : 1;
				const yearVal = parseInt(dots[4]);
				day = day && !!dots[1];
				month = month && !!dots[1];
				return new Date(yearVal, monthVal - 1, dayVal);
			}
			else if (slashes) {
				const dayVal = !!slashes[1] && !!slashes[2] ? parseInt(slashes[1]) : 1;
				const monthVal = slashes[1] ? (slashes[2] ? parseInt(slashes[2]) : parseInt(slashes[1])) : 1;
				const yearVal = parseInt(slashes[3]);
				day = day && !!slashes[1] && !!slashes[2];
				month = month && !!slashes[1];
				return new Date(yearVal, monthVal - 1, dayVal);
			}
			else return new Date(d);
		}
		else if (date instanceof Date)
			return date as Date;
		else
			return null;
	};
	const dateStr = (d: Date) => {
		let result = d.getFullYear().toString();
		if (month)
			result += (d.getMonth() + 1).toString().padStart(2,'0');
		if (day)
			result += d.getDate().toString().padStart(2,'0');
		return result;
	};
	const l = makeDate(lhs);
	const m = makeDate(mhs);
	const r = makeDate(rhs);
	if (!l || !m || !r) return false;
	return dateStr(l) <= dateStr(m) && dateStr(m) <= dateStr(r);
};

// Generischer anyOf-Helper für Array-Felder
export const anyOf = function(a: any[], func: (val: number|string, ...args: (number|string)[]) => boolean, cfunc?: any, ...args: (number|string)[]) { if(a==null) return false;for (let i=0; i < a.length; ++i) { const el = a[i]; if(!(el==null)&&func(cfunc?cfunc(el):el,...args)) return true; } return false; };

/**
 * Standard-Operators-Dictionary.
 * Enthält Operator-Definitionen für string, number und date Typen.
 */
export const Operators: any = {
	"string": {
		"equals": {
				"text": "=",
				"operands": 1,
				"func": equals.toString()
		},
		"notequals": {
			"text": "&ne;",
			"operands": 1,
			"func": notequals.toString()
		},
		"empty": {
				"text": "ist leer",
				"operands": 0,
				"func": stringIsEmpty.toString()
		},
		"notempty": {
			"text": "ist nicht leer",
			"operands": 0,
			"func": stringIsNotEmpty.toString()
		},
		"contains": {
			"text": "enthält",
			"operands": 1,
			"func": stringContains.toString()
		},
		"notcontains": {
			"text": "enthält nicht",
			"operands": 1,
			"func": stringDoesNotContain.toString()
		},
	},
	"number": {
		"equals": {
				"text": "=",
				"operands": 1,
				"func": equals.toString()
		},
		"empty": {
				"text": "ist leer",
				"operands": 0,
				"func": numberIsEmpty.toString()
		},
		"lessOrEqual": {
				"text": "&leq;",
				"operands": 1,
				"func": lessOrEqual.toString()
		},
		"greaterOrEqual": {
				"text": "&geq;",
				"operands": 1,
				"func": greaterOrEqual.toString()
		},
		"liesBetween": {
				"text": "liegt zwischen",
				"operands": 2,
				"func": liesBetween.toString()
		}
	},
	"date": {
		"equals": {
				"text": "=",
				"operands": 1,
				"func": dateEquals.toString()
		},
		"notequals": {
				"text": "&ne;",
				"operands": 1,
				"func": dateNotequals.toString()
		},
		"lessOrEqual": {
				"text": "&leq;",
				"operands": 1,
				"func": dateLessOrEqual.toString()
		},
		"greaterOrEqual": {
				"text": "&geq;",
				"operands": 1,
				"func": dateGreaterOrEqual.toString()
		},
		"liesBetween": {
				"text": "liegt zwischen",
				"operands": 2,
				"func": dateLiesBetween.toString()
		}
	}
};

// Generische CouchDB-Filter
export const bounds_checkout_filter = function (doc: any, req: any) { if (doc._id.startsWith('_design/')) return true; const regions = JSON.parse(req.query.regions); for (const r of regions){ if (doc.header && doc.header.koordinaten && (doc.header.koordinaten.x >= r.l.x && doc.header.koordinaten.x <= r.u.x) && (doc.header.koordinaten.y >= r.l.y && doc.header.koordinaten.y <= r.u.y)) return true;} return false; ; }
export const design_filter = function (doc: any, req: any) { return doc._id.startsWith('_design/'); }
